/**
 * Created by HYL.
 * 角色相关api
 */
import * as API from './'

export default {
  //加载数据字典数据
  init:params=>{
    return API.GET('/api/role/init', params)
  },

  //查询获取role列表(通过page分页)
  findList: params => {
    return API.GET('/api/role/list', params)
  },

  //查询获取一条role信息
  findById: id => {
    return API.GET('/api/role/getDetail/'+id)
  },
  //查询获取一条role信息
  findByOrgId: params => {
    return API.GET('/api/role/getRoleByOrgId',params)
  },

  add: params => {
    return API.postJsonRequest('/api/role/insert', params)
  },
  update: params => {
    return API.postJsonRequest('/api/role/update', params)
  },

  //单个删除role
  remove: params => {
    return API.postJsonRequest(`/api/role/delete/`,params)
  },

  //批量删除，传ids数组
  removeBatch: (ids) => {
    return API.postJsonRequest(`/api/role/batch/${ids}`)
  }

}



// WEBPACK FOOTER //
// ./src/api/api_role.js